import SceButton from '../../../../../../../../Common/CommonComponents/sceButton.js';
import SceText from '../../../../../../../../Common/TextBox/sceText.js';
import classes from './editEmailAddress.scss';
import { getLocalizedStrings } from './popUpCommonStrings.js';
import Modal from 'react-awesome-modal';
// ------------
const EditEmailDialogBox = (props) => {
  const strings = getLocalizedStrings('editEmailDialog');
  return (
    <div className={classes.scrollDiv}>
      <Modal
        visible='true'
        effect="fadeInUp"
        width="100%"
        height="100%">
      <div className={classes.sceAddEmailDialog}>
        <div className={'row ' + classes.sceAddEmailDialogWrap}>
          <div className={'col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ' + classes.sceAddEmailDialogMain}>
            <div className={classes.sceCancelDialogSection}>
              <div className={classes.sceCancelDialogInfo}>
                <div className={classes.sceDialogMainContent}>{strings.editEmailHeading}</div>
                <div className={classes.sceDialogNote}>{strings.editEmailNote}</div>
                <div className={classes.sceDialogSubContent}>
                  <SceText placeholder={props.editVal}
                    type='email'
                    id='emailAddressToBeEdited'
                    disabled='true'
                  />
                </div>
                <div className='sce-space-xs' />
                <SceText placeholder={strings.placeholder}
                  type='cppResEmail'
                  maxLength={45}
                  id='editEmailAddress'
                  validator={app.appUtil.validator}
                  onTextUpdatedHandler={props.retrievedataFromTextBoxes}
                  isError={props.editEmailAddress.isError}
                  isValid={props.editEmailAddress.isValid}
                  errorMsg={props.editEmailAddress.errorMsg}
                />
              </div>
              <div className={'row ' + classes.sceCancelDialogActions}>
                <div className={'col-xs-12 col-sm-6 col-sm-push-6 ' + classes.sceConfirmBtn}>
                  {props.editEmailAddress.value === '' || props.editEmailAddress.isError ?
                    <SceButton
                      id='cancelDialogYes'
                      buttonType='sceDisabled'
                      value={strings.btnConfirm}
                      responive='false'
                    /> :
                    <SceButton
                      id='cancelDialogYes'
                      buttonType='sceSmPrimary'
                      value={strings.btnConfirm}
                      responive='false'
                      onClick={() => props.onEditEmailerDialogClick(props.editVal)}
                    />}
                </div>

              <div className={'col-xs-12 col-sm-6 col-sm-pull-6 ' + classes.sceCancelBtn}>

                  <SceButton
                    id='cancelDialogNo'
                    buttonType='sceClose'
                    value={<span id={'cancelDialogno'}>{strings.btnCancel}</span>}
                    responive='false'
                    onClick={(e) => props.onClickCancelHandler(e)}
                    iconType='cancel'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </Modal>
    </div>

  );
};
export default EditEmailDialogBox;